export default __webpack_public_path__ + "static/media/badge.c8c3ff6c.png";